import React, { useEffect, useState } from 'react';
import CostBranchModal from './costBranchModal';
import { BCFieldsDto } from '../../../types';
import BCReferenceForm from './referenceForm';
import PlanningLinesRows from './planningLinesRows';
import { fetchBcCustomers, fetchBcJobsList } from '../../../api/accounts';
import SearchDropdown from '../../global-components/searchDropdown';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { UserDataSeclector } from '../../../redux/selectors/user';
import { useSelector } from 'react-redux';

interface Props {
  section: string;
  bcTypeForm: BCFieldsDto;
  setBCTypeForm: any;
  setBcCustomerCode: any;
  setBcCustomerName: any;
  isAllIn: boolean;
  setIsAllIn: any;
  isHandling: boolean;
  setIsHandling: any;
}
function BusinessCentralMainForm({
  section,
  bcTypeForm,
  setBCTypeForm,
  setBcCustomerCode,
  setBcCustomerName,
  isAllIn,
  setIsAllIn,
  isHandling,
  setIsHandling,
}: Props) {
  const location = useLocation();
  const isManualShipment = location.pathname === '/app/admin/manual-shipments';
  const userData = useSelector(UserDataSeclector);
  const [showCostModal, setShowCostModal] = useState(false);
  const [isAllFiles, setIsAllFiles] = useState(false);
  const [customerList, setCustomerList] = useState<any>();
  const [jobsList, setJobsList] = useState<any>();
  const legOrder = ['P', 'A1', 'T', 'A2', 'D', 'Handling', 'Allin'];
  let sortedPlanningLines: any = [];
  if (isManualShipment) {
    sortedPlanningLines = bcTypeForm.bc_planning_lines;
  } else {
    const otherItems = bcTypeForm.bc_planning_lines.filter(
      (item) => !legOrder.includes(item.leg)
    );
    const legOrderItems = legOrder
      .map((leg) =>
        bcTypeForm.bc_planning_lines.find((item) => item.leg === leg)
      )
      .filter((item) => item);
    sortedPlanningLines = otherItems.concat(legOrderItems);
  }

  const handleUpdateBCTypeForm = (updatedItem: any, index: number) => {
    const updatedPlanningLines = [...sortedPlanningLines];
    updatedPlanningLines[index] = updatedItem;
    setBCTypeForm({
      ...bcTypeForm,
      bc_planning_lines: updatedPlanningLines,
    });
  };

  function fetchCustomers() {
    fetchBcCustomers({ is_pagination: false, isAll: isAllFiles })
      .then((response: any) => {
        if (!response?.data?.is_error) {
          const modifiedMarkupList = response?.data?.content.map(
            (item: any) => ({
              value: item.no,
              label: `${item?.no}|${item?.name}`,
              code: item?.no,
              name: item?.name,
            })
          );
          setCustomerList(modifiedMarkupList);
        }
      })
      .catch((e) => {});
  }

  function fetchJobs() {
    fetchBcJobsList({
      is_pagination: false,
      isAll: isAllFiles,
      bc_userName: userData?.bc_username,
    })
      .then((response: any) => {
        if (!response?.data?.is_error) {
          const modifiedMarkupList = response?.data?.content.map(
            (item: any) => ({
              value: item?.no,
              label: `${item?.no}|${item?.description}|${item?.file_owner}`,
              code: item?.bill_to_customer_no,
              name: item?.bill_to_name,
            })
          );
          setJobsList(modifiedMarkupList);
        }
      })
      .catch((e) => {});
  }
  useEffect(() => {
    fetchCustomers();
  }, []);
  useEffect(() => {
    fetchJobs();
  }, [isAllFiles]);
  return (
    <div>
      <>
        <Row className='align-items-center mt-4'>
          {section === 'NF' ? (
            <Col lg={3}>
              <div className=''>
                <label
                  className='lex-main-18-400 my-auto'
                  htmlFor='bc_customer'
                >
                  Customer
                </label>
                <SearchDropdown
                  id={'bc_customer'}
                  options={customerList && customerList}
                  dontShowAlreadySelected={true}
                  onSelect={(item) => {
                    setBCTypeForm({
                      ...bcTypeForm,
                      bc_customer: item?.value,
                    });
                    setBcCustomerCode(item?.code);
                    setBcCustomerName(item?.name);
                  }}
                />
              </div>
            </Col>
          ) : (
            <Col lg={3}>
              <Row className='align-items-center'>
                <Col lg={8}>
                  <label
                    className='lex-main-18-400 my-auto'
                    htmlFor='bc_job_file'
                  >
                    Job File
                  </label>
                  <SearchDropdown
                    id={'job_search'}
                    options={jobsList && jobsList}
                    dontShowAlreadySelected={true}
                    onSelect={(item) => {
                      setBCTypeForm({
                        ...bcTypeForm,
                        bc_job_number: item?.value,
                      });
                      setBcCustomerCode(item?.code);
                      setBcCustomerName(item?.name);
                    }}
                  />
                </Col>
                <Col lg={4}>
                  <div className='form-check mt-4'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='is_all_files'
                      checked={isAllFiles}
                      onChange={(e) => {
                        setIsAllFiles(e.target.checked);
                      }}
                    />
                    <label
                      className='form-check-label lex-16-300'
                      htmlFor='is_all_files'
                    >
                      All Files?
                    </label>
                  </div>
                </Col>
              </Row>
            </Col>
          )}
          <Col lg={9}>
            <BCReferenceForm
              bcTypeForm={bcTypeForm}
              setBCTypeForm={setBCTypeForm}
            />
          </Col>
        </Row>
      </>
      <div className='ubbe-card w-auto mt-4' id='leg_section'>
        <div className=''>
          <div className=''>
            <div className='p-4'>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className=''>
                  <h5 className='lex-20-500 color-black'>Planning Lines</h5>
                </div>

                <div className=' text-end'>
                  <button
                    type='button'
                    className='btn btn-ubbe-new-blue'
                    onClick={() => setShowCostModal(true)}
                  >
                    Cost & Branch Combinations
                  </button>
                </div>
              </div>
              <div className='overflow-auto'>
                <table className='table'>
                  <thead className='ubbe-table-header'>
                    <tr>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '10%' }}
                      >
                        Line
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '15%' }}
                      >
                        Type
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '30%' }}
                      >
                        Item
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '8%' }}
                      >
                        Branch
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '8%' }}
                      >
                        Cost
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '8%' }}
                      >
                        Location
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '7%' }}
                      >
                        Cost
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '7%' }}
                      >
                        Markup
                      </th>
                      <th
                        className='text-start align-middle ubbe-table-heading-text'
                        style={{ width: '7%' }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody id='rows'>
                    {sortedPlanningLines.length > 0 &&
                      sortedPlanningLines.map((item: any, index: any) => (
                        <PlanningLinesRows
                          key={index}
                          updateBCTypeForm={(updatedItem: any) =>
                            handleUpdateBCTypeForm(updatedItem, index)
                          }
                          line={item}
                          index={index}
                          isAllIn={isAllIn}
                          setIsAllIn={setIsAllIn}
                          isHandling={isHandling}
                          setIsHandling={setIsHandling}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showCostModal && (
        <CostBranchModal onClose={() => setShowCostModal(false)} />
      )}
    </div>
  );
}

export default BusinessCentralMainForm;
